// Спроба переписати на jQuery

let jq = jQuery.noConflict();

jq(document).ready(function ($) {

    if (navigator.userAgent.search("Firefox") >= 0){
        $('html').addClass('firefox');
    }

    var classes = {
        active: "active"
    };

//функция которая добаляет класс актив
    var toggleElement = function toggleElement(button, menu) {
        if (button) {
            button.addEventListener("click", function () {
                menu.classList.toggle('active');
            });
        }
    };




    var box = $(".price-items"), x;
    $("#price-right-arrow").click(function() {
            x = ((box.width() / 2)) + box.scrollLeft();
            box.animate({
                scrollLeft: x,
            })
    })
    $("#price-left-arrow").click(function() {
            x = ((box.width() / 2)) - box.scrollLeft();
            box.animate({
                scrollLeft: -x,
            })
    })





//хлебние крохи
    var breadcrumbsBtn = document.querySelector('.breadcrumbs_click-area-btn');
    var breadcrumbsMenu = document.querySelector('.breadcrumbs');
    toggleElement(breadcrumbsBtn, breadcrumbsMenu);

    //article description описание стати на h2
    var articleDescriptionTitle = document.querySelector('.aticle_description_title');
    var articleListMenu = document.querySelector('.articleBox_description');
    toggleElement(articleDescriptionTitle, articleListMenu);


    // Переключалка теми
    let bd = $(':root')
    let ntcb = $('.nav-theme__checkbox');
    let palette = sessionStorage['palette'];
    if (palette === undefined) {
        sessionStorage['palette'] = 'dark'
        bd.removeClass('light');
        bd.addClass('dark');
        ntcb.prop('checked', true);
    } else {
        if (palette === 'dark') {
            bd.removeClass('light');
            bd.addClass('dark');
            ntcb.prop('checked', true);
        } else {
            bd.removeClass('dark');
            bd.addClass('light');
            ntcb.prop('checked', false);
        }
    }
    ntcb.on("click", function () {
    })
    $('.btn').on("mousemove", function (e) {
        let btn = $(this);
        btn.css('--mouse-y', e.offsetY + "px");
        btn.css('--mouse-x', e.offsetX + "px");
    });

    // переключалка FAQ
    $('.faq-item').on("click",function () {
        if ($(this).hasClass('selected')){
            $(this).removeClass('selected');
        }else{
            $('.faq-item').removeClass('selected');
            $(this).addClass('selected');
        }

    })


    //    new Rellax(".relax");
    new WOW().init();
    // бургер
    $('.header-menu__button').on("click", function () {
        $(this).toggleClass("active")
        $('.header').toggleClass("active")
    })

    $('.services-item__link').on("click", function () {
        $('.header').removeClass("active")
        $(this).location($(this).attr('href'))
    })

    $(".btn").mousemove(function (pos) {
        cs = $(this)
        cs.css({'--mouse-x': pos.offsetX + "px", '--mouse-y': pos.offsetY + "px"});
    })

    $(window).on('scroll', function () {
        let w = $(this)
        $('.section').each(function () {
            let cs = $(this)
            if (w.scrollTop() > cs.offset().top - w.innerHeight() / 2) cs.removeClass('hidden')
        })

    })
    $('.back-to-top').click(function () {
        $('body,html').animate({scrollTop: 0}, 800);
    });
    $(window).scroll(function () {
        let w = $(this);
        let scrolled = w.scrollTop();
        if (scrolled > (w.innerHeight())) {
            $('.home .back-to-top').addClass('active');
            $('.home .header').addClass('special');

        } else {
            $('.home .back-to-top').removeClass('active');
            $('.home .header').removeClass('special');
        }

        if (scrolled > (100)) {
            $('body').not('.home').find('.back-to-top').addClass('active');
            $('body').not('.home').find('.header').addClass('special');
            $('.article_wrapper .articleBox .article_category').addClass('nailed');

        } else {
            $('body').not('.home').find('.back-to-top').removeClass('active');
            $('body').not('.home').find('.header').removeClass('special');
            $('.article_wrapper .articleBox .article_category').removeClass('nailed');

        }
    });





    let lastScrollTop = 0;
    $(window).on('scroll', function () {
        let w = $(this)
        st = w.scrollTop();
        if ((st < lastScrollTop) && (st > (w.innerHeight()))) {
            $('.home .header').addClass('specialshow');
        } else {
            $('.home .header').removeClass('specialshow');
        }
        if ((st < lastScrollTop) && (st > (100))) {
            $('body').not('.home').find('.header').addClass('specialshow');
        } else {
            $('body').not('.home').find('.header').removeClass('specialshow');
        }
        lastScrollTop = st;
    });


    let teamleft_btn = $('.section-team .left-slider-arrow');
    let teamright_btn = $('.section-team .rigth-slider-arrow');
    let teamtarg = document.getElementsByClassName('team-list')[0];
//    teamtarg.style.scrollBehavior='smooth';
    teamleft_btn.on("click", function () {
        teamtarg.scrollLeft -= 250;
    });
    teamright_btn.on("click", function () {
        teamtarg.scrollLeft += 250;
    });

    let priceleft_btn = $('.section-price .left-slider-arrow');
    let priceright_btn = $('.section-price .rigth-slider-arrow');
    let pricetarg = document.getElementsByClassName('price-list')[0];
//    pricetarg.style.scrollBehavior='smooth';
    priceleft_btn.on("click", function () {
        pricetarg.scrollLeft -= 300;
    });
    priceright_btn.on("click", function () {
        pricetarg.scrollLeft += 300;
    });


    $('.menu__language--active').on("click", function () {
        $(this).parent().parent().toggleClass('show');
        return false;
    })


    $('.category__item.haschildren>.category__title_box').on("click", function () {
//        $('.category__item.haschildren').removeClass('active');
        $(this).parent().toggleClass('active');
        return false;
    })


    $('.news_title_wrapper').on("click", function () {
        $(this).parent().toggleClass('active');
        //return false;
    })

    $('.category__main_title').on("click", function () {
        $(this).find('.category__list').toggleClass('active');
        $(this).parent().toggleClass('active');
        //return false;
    })

    $('.services-items .parent>a').append('<i class="fa-solid fa-chevron-right"></i>');

    $('.services-items>.parent').on("click", function () {
        // переключалка підменю

        if ($(this).hasClass('active')) {
            $(this).siblings().removeClass('active');
            $(this).siblings().find('.mod-menu__sub').removeClass('services-items').removeClass('show');
            $(this).parent().removeClass('hidden');
            $(this).parent().parent().prev().removeClass('show');
            $(this).parent().parent().parent().removeClass('exo');
            $(this).append($(this).next().find('.active').find('.mod-menu__sub').removeClass('header-list__items').removeClass('services-items').removeClass('show'))

            $(this).removeClass('active').parent().parent().prev().children('h2').text('');
        } else {

            $(this).siblings().removeClass('active');
            $(this).parent().addClass('hidden');
            $(this).parent().parent().prev().addClass('show').parent().addClass('exo');
            $(this).siblings().find('.mod-menu__sub').removeClass('services-items').removeClass('show');
            $(this).parent().parent().append($(this).find('.mod-menu__sub').addClass('header-list__items').addClass('services-items').addClass('show'));

            $(this).addClass('active').parent().parent().prev().children('h2').text($(this).children('a').text());
        }
        return false;
    })

    $('.services-img').on("click", function () {
        let menuhid = $(this).next().find('.hidden');
        let submenu = $(this).next().children('.mod-menu__sub');
        menuhid.find('.active').append(submenu.removeClass('header-list__items').removeClass('services-items').removeClass('show'))
        menuhid.removeClass('hidden').children('.active').removeClass('active');
        $(this).removeClass('show');
        return false;
    })


    $('nav.mod-breadcrumbs__wrapper').after($('.com-content-category-blog h1'));

})


function hparser(contentsclass, linksclass) {
    const artyclecontent = document.getElementsByClassName(contentsclass);
    // Додавання "змісту" якщо відсутній в шаблоні.
    const artyclesummary = document.getElementsByClassName(linksclass)[0];
    if (!artyclesummary) {
        let artyclesummary = document.createElement('ul');
        artyclesummary.classList.add(linksclass);
        if (artyclecontent[0]) {artyclecontent[0].before(artyclesummary);}
    }
    [].forEach.call(artyclecontent, function (content, index) {
        let headers = content.querySelectorAll("h2,h3");
        [].forEach.call(headers, function (header, index) {
            let cid = 'asummaryid_' + header.localName + '_' + index;
            header.id = cid;
            let asuli = document.createElement('li');
            let asua = document.createElement('a');
            asua.href = '#' + cid;
            asua.text = header.innerText;
            asuli.classList.add(header.localName + '_type');
            asuli.appendChild(asua);
            artyclesummary.appendChild(asuli);

        })
    })
}


document.addEventListener("DOMContentLoaded", () => {
    hparser('articleBox_content', 'articleBox_description_list');
});



